import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination } from "react-headless-pagination";

export const PaginationComponent = ({
  totalPages,
  currentPage,
  setCurrentPage,
}: {
  totalPages: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}) => {
  return (
    <div className="mt-10 px-5">
      <Pagination
        totalPages={totalPages}
        edgePageCount={3}
        middlePagesSiblingCount={1}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        className="flex items-center"
        truncableClassName="w-10 h-10 flex items-center justify-center"
      >
        <Pagination.PrevButton className="text-sm font-semibold text-gray-400 space-x-2">
          <FontAwesomeIcon icon={faArrowLeft} />
          <span className="hidden md:inline-block">Previous</span>
        </Pagination.PrevButton>
        <nav className="flex justify-center flex-grow">
          <ul className="flex items-center">
            <Pagination.PageButton
              activeClassName="bg-gray-100 text-gray-800"
              inactiveClassName="text-gray-600"
              className="w-10 h-10 flex items-center justify-center text-sm font-medium cursor-pointer"
            />
          </ul>
        </nav>
        <Pagination.NextButton className="text-sm font-semibold text-gray-600 space-x-2">
          <span className="hidden md:inline-block">Next</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </Pagination.NextButton>
      </Pagination>
    </div>
  );
};
